export default function headerHandler() {
	const headerElement = document.querySelector('#site-header');

	if (headerElement) {
		const updateHeaderClasses = () => {
			if (window.scrollY > 1) {
				headerElement.classList.add('is-fixed');
				document.body.classList.add('has-fixed-header');
			} else {
				headerElement.classList.remove('is-fixed');
				document.body.classList.remove('has-fixed-header');
			}
		};
		
		updateHeaderClasses();

		window.addEventListener('scroll', updateHeaderClasses);
	}
}
